import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { database } from '../supabase';
import { REQUIRE_ONBOARDING } from '../config/features';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isCheckingOnboarding, setIsCheckingOnboarding] = useState(!REQUIRE_ONBOARDING ? false : true);
  const [needsOnboarding, setNeedsOnboarding] = useState(false);

  useEffect(() => {
    if (!REQUIRE_ONBOARDING) {
      setNeedsOnboarding(false);
      setIsCheckingOnboarding(false);
      return;
    }

    const checkOnboardingStatus = async () => {
      if (user) {
        try {
          console.log('Checking onboarding status for user:', user.uid);
          
          // Add a small delay to ensure database updates are processed
          await new Promise(resolve => setTimeout(resolve, 500));
          
          // First check if user exists in Supabase
          const supabaseUser = await database.getUserByFirebaseUid(user.uid);
          console.log('Supabase user:', supabaseUser);
          console.log('User ID:', supabaseUser?.id);
          console.log('Firebase UID:', supabaseUser?.firebase_uid);
          
          if (!supabaseUser) {
            console.log('User not found in Supabase, needs onboarding');
            setNeedsOnboarding(true);
          } else {
            const hasCompleted = supabaseUser.onboarding_completed;
            console.log('Onboarding completed status:', hasCompleted);
            console.log('Type of onboarding_completed:', typeof hasCompleted);
            setNeedsOnboarding(!hasCompleted);
          }
        } catch (error) {
          console.error('Error checking onboarding status:', error);
          // Default to showing onboarding if there's an error
          setNeedsOnboarding(true);
        }
      }
      setIsCheckingOnboarding(false);
    };

    checkOnboardingStatus();
  }, [user]);

  // Show loading while checking onboarding status
  if (isCheckingOnboarding) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading...
      </div>
    );
  }

  // If user needs onboarding, redirect to onboarding page (but not if already on onboarding page)
  if (needsOnboarding && location.pathname !== '/onboarding') {
    console.log('Redirecting to onboarding...');
    navigate('/onboarding');
    return null;
  }

  console.log('User has completed onboarding, showing protected content');
  // User has completed onboarding, show the protected content
  return children;
};

export default ProtectedRoute;
